import assertNever from '@watershed/shared-util/src/assertNever';
import { EmissionsYearSource } from '@watershed/constants/finance';

export function isSourceEstimationEngine(
  source: EmissionsYearSource | null | undefined
) {
  switch (source) {
    case EmissionsYearSource.CompanyEstimatationEngine:
    case EmissionsYearSource.BuildingEstimationEngine:
    case EmissionsYearSource.MotorVehicleEstimationEngine:
      return true;
    case EmissionsYearSource.PublicDisclosure:
    case EmissionsYearSource.Survey:
    case EmissionsYearSource.SurveyEstimate:
    case EmissionsYearSource.WatershedMeasurement:
    case EmissionsYearSource.ManualEntry:
    case EmissionsYearSource.PrivateCdp:
    case null:
    case undefined:
      return false;
    default:
      assertNever(source);
  }
}
